// extracted by mini-css-extract-plugin
export default {"_hy":"_hy","flag":"navItemCart-module_flag_j0A"};